// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1662":"css/admin-app.6823","7607":"css/app.6823"}[chunkId] + ".css";
};